import React, { Component } from "react";
import { Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';
import * as routes from '../Constants/routes';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import TournamentOptions from "./TournamentOptions";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

class DeckDetails extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      tournamentNames: []
    }
  }

  componentDidMount () {
    var tournaments = this.context.upcomingTournaments;
    var tNames = [];
    tournaments.forEach(function(doc) {
      tNames.push(
        {
        "Name": doc.Name
      });
    })

      this.setState({
        tournamentNames: tNames
      })
  }

  render() {
    var toolbarOptions = [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction
      ['link', 'image'],
      [{ align: '' }],
      [{ align: 'right' }],
      [{ align: 'center' }],
      [{ align: 'justify' }],
    ];

    var modules = {
      toolbar: toolbarOptions
    }

    var filtersStyle = {
      backgroundColor:"white",
      color:"black",
      paddingBottom: 20
    };

    var h2Style = {
      paddingLeft: 10,
      paddingTop: 5,
      fontFamily: "Audiowide, cursive",
      color: "cadetblue"
    };

    var size14 = {
      fontSize: 14
    }

    const {
      deckName,
      author,
      description,
      tournament
    } = this.props;

    const isInvalid =
      deckName === '' ||
      author === '' ||
      description === '';

    return (
      <div id="deckDetails" className="container" style={filtersStyle}>
      <Form onSubmit={this.props.deckSave}>
      <FormGroup row>
        <h2 style={h2Style}>Deck Details</h2>
      </FormGroup>
      <FormGroup row>
        <Label for="deckName" sm={2}>Deck Name</Label>
        <Col sm={10}>
        <Input type="text" id="deckName" value={this.props.deckName} onChange={this.props.deckNameHandler} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="author" sm={2}>Author</Label>
        <Col sm={10}>
        <Input type="text" id="author" value={this.props.author} onChange={this.props.authorHandler} readOnly />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for="description" sm={2}>Description</Label>
        <Col sm={10}>
        <ReactQuill id="description"  modules={modules} value={this.props.description} onChange={this.props.descriptionHandler} theme="snow"/>

        </Col>

      </FormGroup>

        <Button className={(this.props.deckId == "" ? "visible" : "invisible") }
          disabled={isInvalid} onClick={this.props.deckSave} > Save
        </Button>
        <Button className={"ml-4  " + (this.props.deckId != "" ? "visible" : "invisible")}
          disabled={isInvalid} onClick={this.props.deckEdit} > Update
        </Button>
        { this.context.authUser ? <p></p> :
          <p style={size14}>  Please <Link to={routes.LOGIN}>Log In</Link> to save this deck. </p>
        }
      </Form>
      </div>
    )
  }
}

DeckDetails.contextTypes = {
  authUser: PropTypes.object,
  upcomingTournaments: PropTypes.array
};

export default DeckDetails;

/*
<FormGroup row>
  <Label for="tournament" sm={2}>Tournament</Label>
  <Col sm={10}>
  <Input type="select" id="tournament" value={this.props.tournament} onChange={this.props.tournamentHandler} bsSize="sm" >
    <option value=""></option>
    <TournamentOptions tournaments={this.state.tournamentNames} />
  </Input> If a tournament is selected, the deck will not be made public until after the tournament.
  </Col>
</FormGroup>

  <Input type="textarea" id="description" value={this.props.description} onChange={this.props.descriptionHandler} />
*/



// WEBPACK FOOTER //
// ./src/DeckBuilderComponents/DeckDetails.js